<template>
  <div>
    <template v-if="isSuccess">
      <img
        v-if="file.mime.startsWith('image')"
        :src="!contrato ? (file.id ? $apiDocument(file) : file.documentoGrande) :  (file.id ? $contrato(file.id) : file.documentoGrande)"
        class="image-img"
        :style="{ 'max-width':'200px', 'max-height': '200px'}"
        :title="file.nombre"
      />
      <template v-else>
        <v-icon style="font-size:50px;margin-top:5px;">attach_file</v-icon>
        <div style="margin-left:5px;margin-right:5px;padding:5px;width:100%;text-align:center;" :title="file.nombre" class="file-preview-text">{{file.nombre}}</div>
      </template>
    </template>
    <template v-if="isSaving"><v-progress-circular indeterminate color="primary"></v-progress-circular></template>
    <template v-if="isFailed"><span style="margin-left:5px;margin-right:5px;padding:5px;font-size:14px;" :title="file.error" class="file-preview-text error--text"><v-icon color="error" small class="mr-1">error</v-icon>{{file.error}}</span></template>
    <div v-if="interactable" class="image-remove" :title="isFailed ? file.error : file.nombre">
      <v-layout justify-end>
        <v-btn v-if="isSuccess && file.mime.startsWith('image')" color="primary" icon class="no-draggable icon-preview"  @click.stop="$emit('ampliar')">
          <v-icon>zoom_in</v-icon>
        </v-btn>
        <v-btn v-if="file.id" color="primary" icon class="no-draggable icon-preview" @click.stop :href="$apiDocument(file)" target="_blank">
          <v-icon>file_download</v-icon>
        </v-btn>
        <v-btn v-if="deletable" color="primary" icon class="no-draggable icon-preview" @click.stop="$emit('remove')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      file: {
        required: true
      },
      contrato: {
        type: Boolean,
        default: false
      },
      deletable: {
        type: Boolean,
        default: true
      },
      interactable: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      isSaving: function () {
        return this.file.status === 'SAVING'
      },
      isSuccess: function () {
        return this.file.id || this.file.status === 'SUCCESS'
      },
      isFailed: function () {
        return this.file.status === 'FAILED'
      }
    },
    beforeDestroy () {
    }
  }
</script>


<style lang="stylus">
  .image-list-item .image-remove
    z-index 2
    opacity 0
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    transition opacity
    &:hover
      opacity 1

  .icon-preview
    width 34px !important
    height 34px !important

  .image-list-item.hide-remove .image-remove:hover,
  .image-list-item.sortable-chosen .image-remove:hover
    opacity 0

  .image-list-item .image-remove .image-remove-button
    position absolute
    top 0
    right 0

  // .image-list-item .image-remove .image-download-button,
  // .image-list-item .image-remove .image-zoom-button
  //   position absolute
  //   top 0
  //   right 40px

  .image-list-item .image-img
    width 100%
    height 100%
    object-fit contain

  .file-preview-text
    height: 60px;
    max-height: calc(100% - 55px);
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    align-self: baseline;
    word-break: break-all;

</style>







// WEBPACK FOOTER //
// src/components/generic/fileUploader/FilePreview.vue